import React from 'react';

const style = { fontSize: '0.75rem', lineHeight: 1.5, display: 'block' };

const PopperContent = ({ flight }) => {
    if (!flight) return null;

    return (
        <div>
            <span style={{ ...style, display: 'inline' }}>
                {flight.flightDesc} {flight.atd} {flight.dep}-{flight.arr} {flight.ata}
            </span>
            {flight.expectedPax && <div style={style}>Expected: {flight.expectedPax}</div>}
            {flight.actualPax && <div style={style}>Actual: {flight.actualPax}</div>}
        </div>
    );
};

export default PopperContent;
